import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dbLabel } from '../../i18n/dbLabels';
import OwlCarousel from 'react-owl-carousel';
import { app } from "@microsoft/teams-js";

import { imageEndPoint } from '../../apis/env';
import { useNavigate } from 'react-router-dom';
import { userBookMarkApi, getUserBookMarkListApi, removeBookMarkApi } from '../../apis/WebServices';
import { UserContext } from '../../contexts/UserContext';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { message } from 'antd';
import { videoDeepLink } from '../../apis/env';
import leftImg from "./left.png"
import rightImg from "./right.png"

const Swipper = ({ data, fetchAllVideos, fetchVideos, navPrevClass, navNextClass }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { userName, setUserName, userToken } = useContext(UserContext)
  const [BookMarkedTrueIds, setAllBookMarkedTrueIds] = useState([]);

  // FIXED: Fetch bookmarks from dedicated API instead of relying on video.isBookMarked
  useEffect(() => {
    if (data && userToken) {
      fetchBookmarkedVideoIds();
    }
  }, [data, userToken]);
  
  // 🔧 CRITICAL FIX: Cross-component bookmark synchronization
  useEffect(() => {
    const handleBookmarkSync = (event) => {
      console.log('🔄 Swipper: Received bookmark sync event from', event.detail.component);
      // Only refresh if the event came from a different component
      if (event.detail.component !== 'Swipper') {
        fetchBookmarkedVideoIds();
      }
    };
    
    window.addEventListener('bookmarkChanged', handleBookmarkSync);
    return () => window.removeEventListener('bookmarkChanged', handleBookmarkSync);
  }, []);
  
  // FIXED: Dedicated function to fetch bookmarked video IDs
  const fetchBookmarkedVideoIds = async () => {
    try {
      if (!userToken || userToken === 'undefined') {
        console.log('⚠️ Swipper: No user token, skipping bookmark fetch');
        return;
      }
      
      const response = await getUserBookMarkListApi(1, 1000, userToken);
      console.log('🔍 Swipper: Raw bookmark response:', response);
      
      if (response?.isSuccess) {
        // CRITICAL FIX: Backend returns { data: { videos: [...] } }
        let bookmarkData = response.data?.videos || response.data;
        
        // If data is not an array, try to find the array in the response
        if (!Array.isArray(bookmarkData)) {
          console.log('⚠️ Swipper: response.data.videos is not an array, checking for other properties');
          bookmarkData = response.result?.videos || response.items || response.bookmarks || [];
        }
        
        if (Array.isArray(bookmarkData)) {
          const bookmarkedIds = bookmarkData.map(item => item.id || item.videoId).filter(id => id);
          setAllBookMarkedTrueIds(bookmarkedIds);
          console.log('✅ Swipper: Bookmarked IDs fetched from API:', bookmarkedIds);
          console.log('📋 Swipper: State persistence - Loaded', bookmarkedIds.length, 'bookmarked videos');
        } else {
          console.log('⚠️ Swipper: Could not find array in bookmark response');
          setAllBookMarkedTrueIds([]);
        }
      } else {
        console.log('📋 Swipper: No bookmarked videos found');
        setAllBookMarkedTrueIds([]);
      }
    } catch (error) {
      console.error('❌ Swipper: Failed to fetch bookmarked IDs:', error);
      setAllBookMarkedTrueIds([]);
    }
  };


  const handleVideoClick = (data) => {
    const videoId = data?.id;
    const categoryId = data?.categoryId || data?.category?.id;

    console.log('🎬 Swipper: Video click data:', { videoId, categoryId, fullData: data });
    
    if (!videoId || !categoryId) {
      console.error('❌ Swipper: Missing required data for video navigation:', { videoId, categoryId });
      return;
    }

    const subEntityId = `videoId=${videoId}|vId=${categoryId}`;

    const context = encodeURIComponent(
      JSON.stringify({ subEntityId })
    );
    const deepLink = `${videoDeepLink}?context=${context}`;

    console.log('🔗 Swipper: Opening video deep link:', deepLink);
    app.openLink(deepLink);
  };





  const handleNavigate = (id, categoryId) => {
    console.log('🎬 Swipper: handleNavigate called with:', { id, categoryId });
    
    if (!id || !categoryId) {
      console.error('❌ Swipper: Missing required parameters for navigation:', { id, categoryId });
      return;
    }
    
    if (userToken) {
      const data = {
        id,
        categoryId  // This should work with the updated handleVideoClick
      };
      handleVideoClick(data);
    } else {
      console.log('🔄 Swipper: No userToken, using React Router fallback');
      navigate(`/video-detail?videoId=${id}&vId=${categoryId}`);
    }
  };



    const handleAddBookMark = async (id) => {
        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            
            console.log('🎆 Swipper: Bookmark operation started', { videoId: id, isCurrentlyBookmarked: BookMarkedTrueIds.includes(id) });
            
            const isCurrentlyBookmarked = BookMarkedTrueIds.includes(id);
            
            // CRITICAL FIX: Update UI immediately for instant feedback
            if (isCurrentlyBookmarked) {
                setAllBookMarkedTrueIds(prev => prev.filter(itemId => itemId !== id));
            } else {
                setAllBookMarkedTrueIds(prev => [...prev, id]);
            }
            
            if (isCurrentlyBookmarked) {
                console.log('🗑️ Swipper: Removing bookmark for video:', id);
                const response = await removeBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message || 'Bookmark removed successfully');
                    console.log('✅ Swipper: Bookmark removed successfully');
                    // Refresh from API after delay to ensure consistency
                    setTimeout(() => fetchBookmarkedVideoIds(), 500);
                    // 🔧 CRITICAL FIX: Notify other components
                    window.dispatchEvent(new CustomEvent('bookmarkChanged', { 
                        detail: { videoId: id, action: 'remove', component: 'Swipper' } 
                    }));
                } else {
                    // REVERT UI change if API failed
                    setAllBookMarkedTrueIds(prev => [...prev, id]);
                    message.error(response?.message || 'Failed to remove bookmark');
                }
            } else {
                console.log('➕ Swipper: Adding bookmark for video:', id);
                const response = await userBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message || 'Bookmark added successfully');
                    console.log('✅ Swipper: Bookmark added successfully');
                    // Refresh from API after delay to ensure consistency
                    setTimeout(() => fetchBookmarkedVideoIds(), 500);
                    // 🔧 CRITICAL FIX: Notify other components
                    window.dispatchEvent(new CustomEvent('bookmarkChanged', { 
                        detail: { videoId: id, action: 'add', component: 'Swipper' } 
                    }));
                } else {
                    // REVERT UI change if API failed
                    setAllBookMarkedTrueIds(prev => prev.filter(itemId => itemId !== id));
                    message.error(response?.message || 'Failed to add bookmark');
                }
            }
        } catch (error) {
            console.error('❌ Swipper: Bookmark operation failed:', error);
            // REVERT UI change if error occurred
            const isCurrentlyBookmarked = BookMarkedTrueIds.includes(id);
            if (isCurrentlyBookmarked) {
                setAllBookMarkedTrueIds(prev => [...prev, id]);
            } else {
                setAllBookMarkedTrueIds(prev => prev.filter(itemId => itemId !== id));
            }
            message.error(error?.message || 'Bookmark operation failed');
        }
    };

  return (
    <>
      <OwlCarousel
        key={`swipper-working-${data?.length || 0}`}
        dots={false}
        autoplay={true}
        autoplayTimeout={3000}
        rewind={true}
        rtl={false}
        loop={data?.length > 3}
        responsiveClass={true}
        smartSpeed={800}
        nav={!navPrevClass && !navNextClass}
        margin={10}
        mouseDrag={true}
        touchDrag={true}
        responsive={{
          0: { items: 1 },
          600: { items: 2 },
          1024: { items: 3 },
          1366: { items: 3 },
        }}
        navText={[
          `<img src="${leftImg}" alt="Previous" style="width: 30px; height: 30px; cursor: pointer;" />`,
          `<img src="${rightImg}" alt="Next" style="width: 30px; height: 30px; cursor: pointer;" />`
        ]}
      ref={(carousel) => {
        if (carousel && navPrevClass && navNextClass) {
          // Use setTimeout to ensure DOM elements are available
          setTimeout(() => {
            const prevBtn = document.querySelector(`.${navPrevClass}`);
            const nextBtn = document.querySelector(`.${navNextClass}`);
            if (prevBtn && nextBtn) {
              prevBtn.onclick = () => {
                try {
                  carousel.prev();
                } catch (error) {
                  console.warn('Carousel prev navigation failed:', error);
                }
              };
              nextBtn.onclick = () => {
                try {
                  carousel.next();
                } catch (error) {
                  console.warn('Carousel next navigation failed:', error);
                }
              };
              console.log(`✅ Navigation buttons connected for ${navPrevClass}/${navNextClass}`);
            } else {
              console.warn(`⚠️ Navigation buttons not found: ${navPrevClass}/${navNextClass}`);
            }
          }, 100);
        }
      }}
      >

        {data?.map((slide) => (
          <div
            className="item"
            key={slide.id}
            style={styles.slideItem}
          >
            <div className="card explore-box card-animate">
              <div className="explore-place-bid-img" onClick={() => handleNavigate(slide?.id, slide?.category?.id)}>
                <img
                  src={slide.thumbnail}
                  alt={slide.title}
                  className="img-fluid card-img-top explore-img"
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="bg-overlay"></div>
                <div className="place-bid-btn">
                  <a className="cursor-pointer">
                    <i className="ri-play-circle-fill align-bottom me-1"></i>
                  </a>
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="card-title mb-0 flex-grow-1" 
                      style={{ 
                        cursor: "pointer", 
                        fontSize: "14px",
                        lineHeight: "1.2",
                        height: "17px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                      }} 
                      onClick={() => handleNavigate(slide?.id, slide?.category?.id)}>
                    <a className="text-primary">
                      {slide?.title}
                    </a>
                  </h6>
                  <button
                    className="btn btn-sm p-0"
                    onClick={() => handleAddBookMark(slide?.id)}
                    style={{ background: "none", border: "none" }}
                  >
                    <i className={`mdi ${BookMarkedTrueIds.includes(slide?.id) ? "mdi-bookmark" : "mdi-bookmark-outline"} fs-18`} 
                       style={{ 
                           color: BookMarkedTrueIds.includes(slide?.id) ? '#16f69f' : '#6c757d',
                           fontSize: '18px'
                       }}></i>
                  </button>
                </div>
                {slide?.subCategory?.name && (
                  <p className="text-muted mb-1">
                    <small>{dbLabel(slide.subCategory.name, i18n.language)}</small>
                  </p>
                )}
                {slide?.duration && (
                  <p className="text-muted mb-0">
                    <small><i className="ri-time-line me-1"></i>{slide.duration}</small>
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>


    </>
  );
};

const styles = {
  slideItem: {
    position: 'relative',
  },
  imgFluid: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

export default Swipper;